import { useNavigate } from 'react-router-dom';
import { landingStyles } from '../landing.styles';
import { useMediaQuery } from '../hooks/useMediaQuery';

const heroImage = require('../imagenes/mujer-de-costado.jpeg');

export const LandingHero = () => {
	const navigate = useNavigate();
	const isDesktop = useMediaQuery('(min-width: 768px)');

	const handleComenzar = () => {
		// Puedes cambiar esto por la ruta que desees
		navigate('/app/login');
	};

	return (
		<section style={landingStyles.getHero(isDesktop)}>
			<div style={landingStyles.heroContent}>
				<h2 style={landingStyles.heroTitle}>
					Salud. Estés donde estés.
				</h2>
				<p style={landingStyles.heroText}>
					Accedé de forma simple a especialistas certificados desde cualquier lugar, sin demoras.
				</p>
				<button 
					style={landingStyles.btnPrimary}
					onClick={handleComenzar}
				>
					Comenzar Ahora
				</button>
			</div>
			<img 
				src={heroImage} 
				alt="Telemedicina" 
				style={landingStyles.getHeroImage(isDesktop)}
			/>
		</section>
	);
};

